import i18n from 'i18next';
import '../fonts/Roobert-SemiBold-bold';
import '../fonts/Roobert-Regular-normal';
import { addTextFields } from 'views/report/utils/add-text-fields/add-text-fields.ts';
import { TCoordinates } from 'views/report/types.ts';
import { IProjectsOverview } from 'client/common/interfaces/project.ts';
import translations from 'src/internationalisation/translation-map.json';
import { softGrayColor, stoneGrayColor } from 'views/report/colors.ts';
import { fontNormal, padding } from 'views/report/utils/style-consts.ts';
import { getCenterXPosition, getPageHeight, getPageWidth } from 'views/report/utils/utils.ts';

const getFooterSections = (
  projectOverview: IProjectsOverview,
): {
  sectionLeftSide: { name: string; value: string | number }[];
  sectionRightSide: { name: string; value: string | number }[];
} => {
  const { field, site, country, wellbore, well, design } = projectOverview;
  const sections = [
    [i18n.t(translations.design), design.name],
    [i18n.t(translations.well), well.name],
    [i18n.t(translations.field), field.name],
    [i18n.t(translations.wellbore), wellbore.name],
    [i18n.t(translations.site), site.name],
    [i18n.t(translations.country), country.name],
  ].map(([name, value]) => ({ name, value }));

  const middleIndex = sections.length / 2;

  const sectionLeftSide = sections.slice(0, middleIndex);
  const sectionRightSide = sections.slice(middleIndex, sections.length);

  return { sectionLeftSide, sectionRightSide };
};

const addFooterSections = (doc: any, projectOverview: IProjectsOverview): TCoordinates => {
  let lastYPosition = 0;
  const { sectionLeftSide, sectionRightSide } = getFooterSections(projectOverview);

  const pageHeight = getPageHeight(doc);
  const pageWidth = getCenterXPosition(doc);

  addTextFields(doc, { x: padding + 5, y: pageHeight - 32.5 })(sectionLeftSide);
  lastYPosition = addTextFields(doc, { x: pageWidth, y: pageHeight - 32.5 })(sectionRightSide).y;

  return { x: padding, y: lastYPosition };
};

export const addFooterToPages = (doc: any, projectOverview?: IProjectsOverview): void => {
  const pageHeight = getPageHeight(doc);
  const pageCount = doc.internal.getNumberOfPages() - 1;

  for (let i = 1; i <= pageCount + 1; i++) {
    if (i > 1) {
      doc.setPage(i);

      if (projectOverview) {
        const rectangularHeight = 25;
        const rectangularWidth = getPageWidth(doc) - padding * 2;

        doc.setFillColor(softGrayColor);
        doc.rect(padding, pageHeight - 40, rectangularWidth, rectangularHeight, 'F');
        addFooterSections(doc, projectOverview);
      }

      const pageText = `Page ${i - 1} of ${pageCount}`;

      doc.setFont(fontNormal.fontName, fontNormal.fontStyle);
      doc.setFontSize(10);
      doc.setTextColor(stoneGrayColor);
      doc.text(pageText, getCenterXPosition(doc), pageHeight - 7, {
        align: 'center',
      });
    }
  }
};
